import { render, staticRenderFns } from "./QrCodeInfo.vue?vue&type=template&id=319c84a2&"
import script from "./QrCodeInfo.vue?vue&type=script&lang=js&"
export * from "./QrCodeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports